import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { SwitchContainer } from "./Switch.styles";

export const Switch = ({
  defaultValue = true,
  size = "small",
  onChange = undefined,
  backgroundColor = "#101c42",
  disabled = false,
}) => {
  const [checked, setChecked] = useState(defaultValue);

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  const handleChange = () => {
    if (!disabled) {
      setChecked(!checked);
      onChange(!checked);
    }
  };

  return (
    <SwitchContainer>
      <div className={`secondary size-${size} ${disabled ? "disabled" : ""}`}>
        <label>
          <input
            type="checkbox"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
          />
          <span
            className={`slider size-${size}`}
            style={{ backgroundColor }}
          ></span>
        </label>
      </div>
    </SwitchContainer>
  );
};

Switch.propTypes = {
  defaultValue: PropTypes.bool,
  backgroundColor: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
